var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.86 0H2.14C.96 0 0 .97 0 2.16v25.68C0 29.03.96 30 2.14 30h25.72c1.18 0 2.14-.97 2.14-2.16V2.16C30 .97 29.04 0 27.86 0ZM9.06 25.71H4.63V11.4h4.45v14.3ZM6.85 9.44a2.58 2.58 0 1 1 0-5.16 2.58 2.58 0 0 1 0 5.16Zm18.9 16.27H21.3v-6.96c0-1.66-.04-3.8-2.31-3.8-2.32 0-2.67 1.81-2.67 3.68v7.08h-4.45V11.4h4.27v1.95h.06a4.68 4.68 0 0 1 4.2-2.3c4.5 0 5.34 2.96 5.34 6.82v7.84Z"
  })));
};
export default SvgLinkedin;